<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-point`]" width="1em" height="1em" v-bind="$attrs"><circle cx="8" cy="8" r="3"/></svg>
</template>
<script>

export default {
  name: 'IconFillPoint',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
